<template>
    <div class="social-box">
        <Marketing :marketingData='marketingData' class="black"></Marketing>
        <SocialMedia class="black"></SocialMedia>
        <SocialFacebook class="black"></SocialFacebook>
        <Expert :expertData='expertData' class="black"></Expert>
        <DoBetter :childModle='childModleDatatwo' class="itemtwo black"></DoBetter>
        <Hat :hatData='hatData' class="fristhat black"></Hat>
        <Expert :expertData='expertData2' class="number4 black"></Expert>
        <!-- <OurServe :serveData='serveData' :swiperOptions='swiperOptions' :scrollbar='scrollbar' class="white"></OurServe> -->
    </div>
</template>
<script>
    import Marketing from '@/components/main/home/marketing'//引入数字化营销服务
    import SocialMedia from '@/components/main/project/socialmedia'//引入内容
    import SocialFacebook from '@/components/main/project/socialfacebook'//引入内容
    import Expert from '@/components/main/project/expert'//引入内容
    import DoBetter from '@/components/main/contact/dobetter'//引入图文
    import Hat from '@/components/main/project/hat'//引入说明布局 
    // import OurServe from '@/components/main/home/ourserve'//引入我们的服务
    export default {
        name: 'Social',
        data() {
            return {
                marketingData: {//第四屏的数据
                    title: '社交媒体推广',
                    caption: 'Social Media',
                    showdown: 'Marketing Services',
                    textData: ['ENCOURAGE POSITIVE FEEDBACK SHARE', 'INNOVATION CULTIVATE INDUSTRY PROFESSIONAL'],
                    chinese: '<p>您是否正在寻找一种有效的方法来提高企业的品牌知名度和网站流量？</p><p>然后，您应该在社交媒体上！</p><p>获取我们的社交媒体推广服务，并建立强大的社交媒体形象。</p>',
                    // english: '<p>我们拥有10年数字营销与网站设计开发经验、 100多项经典案例。</p><p>我们的成员由数字营销策划、交互设计、数字前端及整合平台研发专家组成。</p>',
                },
                childModleDatatwo: {
                    center: '通过buzzsumo、ahrefs等工具对本行业进行市场调研和行业关键词调研，多维度收集目标行业话题和文章主题。<br/><br/>并让母语系老外进行内容的撰写，从而提升个人页面的行业专业度，引发潜在客户对我们的兴趣和关注。',
                    title: '行业知识调研',
                    caption: '02'
                },
                hatData: {
                    title: 'LinkedIn',
                    caption: '添加精准人脉',
                    chinese: '<p>通过前期对目标群体，目标市场，受众肖像，目标职位的调研，编辑高转化率的开发信发送至理想头衔的潜在买家，确保了人脉的精准和质量。</p>',
                },
                expertData: {
                    caption: '如何打造行业专家？',
                    entitle: 'LinkedIn',
                    cncaption: '创建专业的个人页面',
                    cncenter: '“信任感”是推动海外决策者做出选择的关键维度之一，因此专业、真实的个人信息将为我们的成交锦上添花。相关性高的内容和来自真实客户的评价或背书更能引起决策者的兴趣。',
                    itemData: [
                        {
                            icourl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/%E7%BB%84%20779.png',
                            title: '添加专业的个人资料照片、封面'
                        },
                        {
                            icourl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/%E7%BB%84%20776.png',
                            title: '有一个引人注目的标题&个人简介'
                        },
                        {
                            icourl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/%E7%BB%84%20778.png',
                            title: '填写网站、联系信息、学历等'
                        },
                        {
                            icourl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/tj/%E7%BB%84%20777.png',
                            title: '充实当前工作经验和描述、过去经验'
                        }
                    ]
                },
                expertData2: {
                    entitle: 'LinkedIn',
                    cncaption: '持之以恒，投其所好',
                    cncenter: '要在众多竞争者中脱颖而出，就要在信息的内容和形式上花点巧思，尽量贴近决策者的兴趣关键词，务求迅速抓住他的眼球。'
                },
                serveData: {//第三屏的数据
                    caption: '客户案例',
                    title: '不断发布企业形象、公司实力、企业研发、团建照、客户合影、国外展会照片、工厂生产照、工厂流水线照等照片，激发客户询单欲望。',
                    swiperData: [
                        {
                            // imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/banner1.jpg',
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/2.png'
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/4.png',
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/5.png',
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/61.png',
                        },
                        {
                            imgurl: 'https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/7.png',
                        }
                    ]
                },
                swiperOptions: {
                    // autoplay: { //匀速滚动
                    //     delay: 3000, //间隔时间0秒
                    //     stopOnLastSlide: false,
                    //     disableOnInteraction: false, //触摸后仍然执行
                    // },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true,
                        hide: false
                    },
                    mousewheel: true,
                    slidesPerView: 4.5,
                    spaceBetween: 20,
                    grabCursor: true
                    // Some Swiper option/callback...
                },
                scrollbar: '#ffffff'
            }
        },
        components: {
            Marketing,
            SocialMedia,
            SocialFacebook,
            Expert,
            DoBetter,
            Hat,
            // OurServe
        }
    }
</script>
<style scoped>
    .social-box {
        padding-top: 8%;
    }

    .marketing-box>>>.english-box p,
    .marketing-box>>>.chinese-box p {
        font-size: 16px;
        font-weight: 400;
        line-height: 32px;
        color: rgba(102, 102, 102, 1);
    }

    .marketing-box>>>.right-box {
        display: none;
    }

    .marketing-box>>>.left-center-box {
        max-width: auto;
    }

    .marketing-box>>>.left-box {
        width: 100%;
    }

    .marketing-box>>>.text-box {
        width: 56.77%;
        min-height: 570px;
        grid-template-columns: 1fr;
        left: 100%;
        transform: translateX(-100%);
    }

    .marketing-box>>>.text-box::before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 110%;
        height: 630px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/stock-photo-54935020.jpg') no-repeat center;
        background-size: cover;
        transform: translate(-70%, -436px);
    }

    .social-box>>>.marketing-box {
        padding-top: 192px;
        height: 1131px;
    }

    .marketing-box>>>.marquee-text {
        padding-top: 0;
        transform: translateY(-20%);
    }

    .marketing-box>>>.showdown {
        display: block;
        padding-left: 0;
        white-space: nowrap;
        font-family: gilroybold4;
    }

    .social-box .number4 {
        padding-bottom: 280px;
    }

    .number4>>>.imgbox {
        height: 800px;
        background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/stock-photo-245411159.jpg') no-repeat center 32%;
        background-attachment: fixed;
    }

    .number4>>>.center-box {
        position: absolute;
        bottom: 0;
        left: 7.2%;
        background-color: #ffffff;
        width: 56.6%;
        height: 640px;
        transform: translate(0px, 83px);
    }

    .number4>>>.center-box::before {
        content: 'insist';
        text-transform: uppercase;
        display: block;
        font-family: gilroybold4;
        font-size: 120px;
        font-weight: bold;
        line-height: 98px;
        position: absolute;
        transform: translate(0px, -62%) rotate(90deg);
        transform-origin: left bottom;
        top: 0;
        left: 0;
        color: rgba(229, 229, 229, 1);
    }

    .number4>>>.center-box::after {
        display: none;
    }

    .number4>>>.center {
        background-color: transparent;
        align-items: flex-start;
        padding: 5%;
    }

    .number4>>>.shak {
        height: 1033px;
        width: 45.5%;
        left: 47%;
        bottom: 0px;
        transform: translate(0px, 152px);
    }

    .number4>>>.shak::before {
        display: none;
    }

    .number4>>>.center::before {
        content: '04';
        display: block;
        font-family: gilroybold4;
        font-size: 140px;
        font-weight: bold;
        line-height: 169px;
        position: absolute;
        top: 0;
        right: 0%;
        transform: translateX(200%);
        color: rgba(229, 229, 229, 1);


    }

    .number4>>>.center::after {
        content: '04';
        display: inline;
        font-family: gilroybold4;
        font-weight: bold;
        color: transparent;
        text-transform: uppercase;
        position: absolute;
        bottom: 329px;
        right: 0%;
        transform: translate(200%, 0%) rotate(0deg);
        transform-origin: center center;
        font-size: 140px;
        line-height: 169px;
        -webkit-text-stroke: 2px rgba(204, 204, 204, 1);
        text-stroke: 2px rgba(204, 204, 204, 1);
    }

    .number4>>>.cncaption {
        margin-bottom: 50px;
    }

    .social-box .ourserve-box {
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/home/stock-photo-72684347.jpg') no-repeat center;
        background-size: cover;
        background-attachment: fixed;
        margin-bottom: 0;
    }

    .ourserve-box>>>.oneswiper {
        background-color: transparent;
        transform: translateY(0%);
    }

    .ourserve-box>>>.oneswiper .swiperSlider {
        background-color: transparent;
    }

    .ourserve-box>>>.oneswiper .item-img-box {
        height: 580px;
        background-size: 120%;
    }

    .ourserve-box>>>.caption {
        font-size: 42px;
        line-height: 140%;
        max-width: 250px;
    }

    /* 图文样式 */
    .DoBetter>>>.wecat {
        display: none;
    }

    .DoBetter>>>.center-box {
        width: 1448px;
        height: 760px;
        padding-left: 17.1%;
        margin-left: 112px;
    }

    .DoBetter>>>.center-box::after {
        width: 575px;
        height: 737px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/8259019d3ef70c373be081e011404779.jpg') no-repeat center center;
        top: 137px;
        right: -530px;
    }

    .DoBetter>>>.animetionLine,
    .social-box>>>.DoBetter::before {
        display: none;
    }

    .DoBetter>>>.center-box::before {
        content: 'survey';
        transform: rotate(90deg) translate(52%, -140px);
    }

    .DoBetter>>>.title-caption {
        font-size: 42px;
        font-weight: bold;
        line-height: 59px;
        color: rgba(51, 51, 51, 1);
        position: relative;
        margin-bottom: 44px;
    }

    .DoBetter>>>.showdown {
        font-size: 42px;
    }

    .itemtwo>>>.center-box {
        width: 76.6%;
        height: 814px;
    }

    .itemtwo>>>.center-box::after {
        position: absolute;
        content: '';
        display: block;
        width: 600px;
        height: 800px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/photo-1484480974693-6ca0a78fb36b.jpg') no-repeat right;
        background-size: 40% 100%;
        background-attachment: fixed;
        top: -110px;
        right: -275px;
    }

    .social-box .itemtwo {
        padding: 0px 0 249px 0;
    }

    .itemtwo>>>.title-caption::before {
        content: 'LinkedIn';
        display: block;
        /* text-transform: uppercase; */
        position: absolute;
        top: 0;
        left: 0;
        white-space: nowrap;
        color: rgba(36, 136, 248, 1);
        transform: translateY(-150%);
        font-size: 24px;
        font-weight: bold;
        line-height: 33px;
        color: rgba(36, 136, 248, 1);
    }

    .itemtwo>>>.center-caption {
        top: 0;
        left: 229px;
        font-size: 140px;
        font-family: gilroybold4;
        font-weight: bold;
        line-height: 169px;
        -webkit-text-stroke: 2px rgba(153, 153, 153, 1);
        text-stroke: 2px rgba(153, 153, 153, 1);
        color: transparent;
        /* right: 0; */
        transform: translateY(-72%);
    }

    .itemtwo>>>.center-caption::after,
    .social-box>>>.ourserve-box .animetionLine {
        display: none;
    }

    .social-box .fristhat {
        margin-top: 0;
        width: 65.4%;
        height: 660px;
        margin-bottom: 312px;
        background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/stock-photo-115145407.jpg') no-repeat top left;
        background-size: 60% 70%;
        background-attachment: fixed;
        position: relative;
    }

    .fristhat>>>.center-box {
        position: absolute;
        right: 0;
        height: 520px;
        width: 75.3%;
        top: 50%;
        transform: translate(70%, -50%);
    }

    .fristhat>>>.chinese-box {
        max-width: 471px;
    }

    .fristhat>>>.animetionLine,
    .fristhat>>>.left-center-box::before {
        display: none;
    }

    .fristhat>>>.left-center-box::after {
        display: block;
        content: 'Extended';
        position: absolute;
        font-size: 120px;
        font-family: gilroybold4;
        line-height: 100px;
        font-weight: bold;
        text-transform: uppercase;
        color: rgba(241, 241, 241, 1);
        right: 100px;
        transform-origin: right bottom;
        transform: translate(0, 144%) rotate(90deg);

    }

    .social-box>>>.ourserve-box {
        background: #1C1C1C url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/%E7%BB%84%20764.jpg') no-repeat top;
        min-height: auto;
        width: 100%;
        background-size: cover;
        grid-template-columns: 29% 71%;
        background-attachment: fixed;
    }

    .social-box>>>.ourserve-box .text-box {
        padding:15%;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .social-box>>>.ourserve-box .title {
        max-width: 100%;
    }
    .social-box>>>.ourserve-box .oneswiper{
        padding: 5% 0;
        height: auto;
        align-self: center;
        
    }
    .social-box>>>.ourserve-box .oneswiper .item-box{
        height: auto;
    }
    .social-box>>>.ourserve-box .oneswiper .item-img-box{
        height: auto;
        padding-bottom: 15%;
    }

    @media(max-width: 1297px) {
        .marketing-box>>>.showdown {
            white-space: normal;
        }

        .marketing-box>>>.left-box::before {
            left: 0px;
        }

        .marketing-box>>>.animetionLine {
            left: 18px;
        }
    }

    @media(max-width: 995px) {
        .social-box {
            padding-top: 0%;
        }

        .social-box>>>.marketing-box {
            padding-top: 0;
            height: auto;
            margin-top: 10%;
        }

        .marketing-box>>>.text-box {
            width: 100%;
            min-height: auto;
            grid-template-columns: 1fr;
            left: 0%;
            transform: translateX(0%);
        }

        .marketing-box>>>.animetionLine,
        .marketing-box>>>.left-box::before,
        .itemtwo>>>.center-box::after,
        .number4>>>.center-box::before {
            display: none;
        }

        .itemtwo>>>.center-box {
            min-height: auto;
            width: 100%;
            height: auto;
            padding-left: 0;
            margin-left: 0;
        }

        .DoBetter>>>.title-caption {
            font-size: 24px;
            line-height: 140%;
            position: sticky;
            margin-bottom: 0%;
            padding-left: 5%;
        }

        .itemtwo>>>.title-caption::before {

            position: static;
            transform: translateY(0%);
        }

        .itemtwo>>>.mobile-img {
            display: block;
            background: red url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/photo-1484480974693-6ca0a78fb36b.jpg') no-repeat center;
            background-size: cover;
            width: 100%;
            height: 70vw;
        }

        .itemtwo>>>.center-caption {
            top: 0;
            left: 100%;
            font-size: 150px;
            line-height: 120%;
            -webkit-text-stroke: 1px rgba(153, 153, 153, 1);
            text-stroke: 1px rgba(153, 153, 153, 1);
            color: #fff;
            transform: translate(-100%, 0%);
        }

        .social-box .itemtwo {
            padding: 0;
        }

        .social-box .fristhat {
            margin-top: 0;
            width: 100%;
            height: auto;
            margin-bottom: 0px;
            background: #fff url('');
            background-attachment: initial;
            position: relative;
        }

        .fristhat>>>.center-box {
            position: static;
            display: block;
            height: auto;
            width: 100%;
            transform: translate(0%, 0%);
        }

        .fristhat>>>.left-center-box {
            max-width: 100%;
            padding: 5%;
            padding-top: 0;
        }

        .fristhat>>>.caption {
            font-size: 24px;
            font-weight: bold;
            line-height: 100%;
            margin: 1% 0;
        }

        .fristhat>>>.left-center-box::after,
        .number4>>>.shak {
            display: none;
        }

        .number4>>>.center-box {
            position: static;
            background-color: #ffffff;
            width: 100%;
            height: auto;
            transform: translate(0px, 0px);
            justify-content: flex-start;
            padding: 0;
        }

        .number4>>>.cncenter {
            margin: 1% 0;
        }

        .number4>>>.cncaption {
            margin-bottom: 0px;
        }

        .number4>>>.imgbox {
            height: auto;
            background: #666666 url('') no-repeat center 32%;
            background-attachment: initial;
        }

        .number4>>>.center {
            padding-top: 0%;
        }

        .social-box .number4 {
            padding-bottom: 10%;
        }
        .social-box>>>.ourserve-box{
            grid-template-columns: 100%;
        }

        .social-box>>>.ourserve-box .text-box {
            padding: 5%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .social-box>>>.ourserve-box .title {
            max-width: 100%;
            margin-top: 0;
        }

        .social-box>>>.ourserve-box .caption {
            font-size: 24px;
        }
        .social-box>>>.ourserve-box .oneswiper{
       display: none;
    }
    .social-box>>>.ourserve-box{}

    }

    /* @media(max-width: 1023px) {
        .marketing-box>>>.text-box::before {
            display: none;
        }

        .marketing-box>>>.text-box {
            width: 100%;
            height: auto;
            grid-template-columns: 1fr;
            left: 0;
            transform: translateX(0%);
        }

        .marketing-box>>>.english-box p,
        .marketing-box>>>.chinese-box p {
            font-size: 50px;
            line-height: 200%;
        }

        .marketing-box>>>.left-box {
            background-color: rgba(255, 255, 255, .6);
        }

        .marketing-box>>>.marquee-text p {
            font-size: 250px;
            font-weight: bold;
            line-height: 120%;
        }

        .marketing-box>>>.marquee-text>p:first-child {
            margin-top: 10%;
        }

        .itemtwo>>>.center-box {
            width: 100%;
            height: 1014px;
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/photo-1484480974693-6ca0a78fb36b.jpg') no-repeat center;
            background-size: cover;
            background-attachment: initial;
            margin-left: 0;
        }

        .itemtwo>>>.center-box::after {
            display: none;
        }

        .social-box .itemtwo {
            padding: 0px 0 800px 0;
        }

        .itemtwo>>>.title-caption {
            font-size: 72px;
            line-height: 140%;
            transform: translateY(100%);
        }

        .itemtwo>>>.title-caption::before {
            font-size: 50px;
            line-height: 137%;
        }

        .itemtwo>>>.center-caption {
            transform: translateY(200%);
        }

        .social-box .fristhat {
            margin-top: 0;
            width: 90%;
            height: 1200px;
            margin-bottom: 400px;
            background: transparent url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/stock-photo-115145407.jpg') no-repeat center;
            background-size: cover;
            background-attachment: initial;
        }

        .fristhat>>>.center-box {
            height: 1020px;
            width: 80%;
            top: 50%;
            transform: translate(-24%, -30%);
            background-color: #ffffff;
        }

        .fristhat>>>.left-center-box::before {
            display: none;
        }

        .fristhat>>>.animetionLine {
            display: none;
        }

        .fristhat>>>.left-center-box {
            max-width: 100%;
            padding-left: 10%;
        }

        .fristhat>>>.chinese-box {
            max-width: 80%;
        }

        .fristhat>>>.chinese-box p {
            font-size: 50px;
            line-height: 150%;
        }

        .fristhat>>>.title {
            font-size: 50px;
            line-height: 120%;
        }

        .fristhat>>>.caption {
            font-size: 75px;
            line-height: 120%;
        }

        .number4>>>.center::after {
            display: none;
        }

        .number4>>>.shak {
            display: none;
        }

        .number4>>>.imgbox {
            height: 1200px;
            background: #666666 url('https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/stock-photo-245411159.jpg') no-repeat center;
            background-size: cover;
            background-attachment: initial;
        }

        .number4>>>.center-box {
            bottom: 0;
            left: 50%;
            width: 90%;
            transform: translate(-50%, 50%);
        }

        .social-box .number4 {
            padding-bottom: 1180px;
        }

        .social-box .ourserve-box {
            background: transparent;
            margin-bottom: 0;
        }

        .ourserve-box>>>.text-box {
            background: transparent url(https://lanjingshuziguanwang-public.oss-cn-hangzhou.aliyuncs.com/IMG/project/%E7%BB%84%20764.jpg) no-repeat center;
            background-size: cover;
            background-attachment: initial;
            padding: 5%;
        }

        .ourserve-box>>>.twoswiper {
            height: 1800px;
            transform: translateY(0%);

        }

        .ourserve-box>>>.item-img-box {
            width: 100%;
            height: 100%;
            background-size: 60%;
            overflow: hidden;
        }

    }

    @media(max-width: 436px) {
        .social-box>>>.marketing-box {
            height: 1631px;
        }
        .number4>>>.center-box {
            width: 100%;
            transform: translate(-50%, 80%);
        }
        .number4>>>.center{
            padding-top: 4%;
        }
        .number4>>>.cncenter{
            max-width: 90%;
        }
    }
    @media(max-width: 375px){
         .social-box .itemtwo {
             padding-bottom: 1000px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/pages/main/porject/social.vue